import React from 'react';
import { usePageTitle } from '../hooks';
import { useSimulationResults } from '../hooks/useSimulationResults';
import { ResultsContainer } from '../components/simulations/results';

/**
 * SimulationResultsPage - Thin wrapper component for simulation results
 *
 * This page component has been refactored to delegate all logic to the
 * ResultsContainer component for better modularity and maintainability.
 */
const SimulationResultsPage: React.FC = () => {
  // Get simulation data for dynamic title
  const { simulation } = useSimulationResults();

  // Dynamic page title based on simulation status
  const pageTitle = React.useMemo(() => {
    if (!simulation) return 'Simulation Results';

    const isProcessing = !simulation.resultJson ||
      simulation.status === 'queued' ||
      simulation.status === 'processing';

    if (isProcessing) {
      return simulation.status === 'processing'
        ? 'Generating Simulation...'
        : simulation.status === 'queued'
        ? 'Queued - Simulation'
        : 'Preparing Simulation';
    }

    if (simulation.status === 'failed') {
      return 'Failed - Simulation';
    }

    return 'Simulation Results';
  }, [simulation?.status, simulation?.resultJson]);

  usePageTitle(pageTitle);

  return <ResultsContainer />;
};

export default SimulationResultsPage;